import { CTAFunction } from "../../../api/cta/ctaFunction/CTAFunction";
import { PlayerCTAAPI } from "../../../api/cta/PlayerCTAAPI";
import { ClickableAreaCTAConfiguration } from "./ClickableAreaCTAConfiguration";

const ACTION_ID = 0;

export const clickableAreaCTAFunction: CTAFunction = (
  api: PlayerCTAAPI,
  ctaId: number,
  ctaBoard: HTMLElement,
  config: ClickableAreaCTAConfiguration,
) => {
  const clickableArea = document.createElement("div");

  clickableArea.setAttribute("class", "clickableAreaItem");
  clickableArea.style.top = `${parseInt(config.top, 10)}%`;
  clickableArea.style.bottom = `${parseInt(config.bottom, 10)}%`;
  clickableArea.style.left = `${parseInt(config.left, 10)}%`;
  clickableArea.style.right = `${parseInt(config.right, 10)}%`;
  clickableArea.style.position = "absolute";
  clickableArea.style.pointerEvents = "all";
  clickableArea.style.cursor = "pointer";

  clickableArea.onclick = () => {
    if (config.scenarioElementId) {
      api.jumpToScenarioElement(config.scenarioElementId);
    } else {
      window.open(config.url, config.target);
    }
    api.onCTAAction(ctaId, ACTION_ID);
  };

  const container = ctaBoard.querySelector("[data-role='container']");
  container.appendChild(clickableArea);

  return {
    action: () => {},
  };
};
